export interface Employee {
	id?: string;
	name?: string;
	gender?: string;
	birth_date?: string;
	wage?: number;
	contract_type?: string;
	[key: string]: unknown;
}

export const DEFAULT_EMPLOYEE: Employee = {
	id: '',
	name: '',
	gender: 'm',
	birth_date: '1980-01-01',
	wage: 25000,
	contract_type: 'onb'
};

// Simplified employee interface for calculations
export interface EmployeeSummary {
	gender: 'male' | 'female';
	wage: number | string | null | undefined;
}

/** Extraction status, mirroring the backend `status` field. */
export type ExtractionStatus = 'in_progress' | 'completed' | 'failed';

/** Extracted employees, present once an extraction has completed. */
export interface ExtractionResult {
	employee_list?: Employee[];
}

/** Shape returned by `GET …/employee-list-extraction-status` (FilePond extract flow). */
export interface ExtractionResponse {
	status: ExtractionStatus;
	result?: ExtractionResult;
}
